// Kaching attaches its per-item bundle submission to the primary buy button.
// Keep Impact's native sticky UI and use that same entry point for bundles.
document.addEventListener('click', (customEvent) => {
  const customStickyButton = customEvent.target.closest?.('product-quick-add button[type="submit"]');
  if (!customStickyButton) return;

  const customForm = customStickyButton.form;
  if (!customForm?.querySelector('[name="properties[__kaching_bundles]"]')) return;

  const customMainButton = customForm.querySelector('.buy-buttons > button[type="submit"]');
  if (!customMainButton || customMainButton === customStickyButton) return;

  customEvent.preventDefault();
  customEvent.stopImmediatePropagation();
  if (!customMainButton.disabled && !customMainButton.hasAttribute('aria-busy')) {
    customMainButton.click();
  }
}, true);

// The bundle app owns pricing and currency formatting. Mirror only its selected
// total, scoped to the product form associated with this sticky bar.
if (!customElements.get('custom-sticky-bundle-price')) {
  customElements.define('custom-sticky-bundle-price', class extends HTMLElement {
    connectedCallback() {
      this.customNativePrice = this.querySelector('[data-custom-native-price]');
      this.customBundlePrice = this.querySelector('[data-custom-bundle-price]');
      this.customValue = this.querySelector('[data-custom-bundle-price-value]');
      this.customRoot = document.getElementById(this.getAttribute('form'))?.closest('.product-info');
      if (!this.customRoot || !this.customNativePrice || !this.customBundlePrice || !this.customValue) return;

      this.customMountSelector = 'kaching-bundle, .kaching-bundles';
      this.customMountObserver = new MutationObserver((customRecords) => {
        const customMountChanged = customRecords.some((customRecord) => {
          // App-internal changes are already handled by the price observer.
          if (this.customApp?.contains(customRecord.target)) return false;
          return [...customRecord.addedNodes, ...customRecord.removedNodes].some((customNode) =>
            customNode instanceof Element && (customNode.matches(this.customMountSelector) || customNode.querySelector(this.customMountSelector))
          );
        });
        if (customMountChanged && this.customBindApp()) this.customSchedule();
      });
      this.customMountObserver.observe(this.customRoot, { childList: true, subtree: true });
      this.customBindApp();
      this.customUpdate();
    }

    disconnectedCallback() {
      this.customMountObserver?.disconnect();
      this.customPriceObserver?.disconnect();
      cancelAnimationFrame(this.customFrame);
      this.customFrame = null;
      this.customApp = null;
      this.customRoot = null;
    }

    customBindApp() {
      const customApp = this.customRoot.querySelector(this.customMountSelector);
      if (customApp === this.customApp) return false;
      this.customPriceObserver?.disconnect();
      this.customApp = customApp;
      if (customApp) {
        this.customPriceObserver = new MutationObserver(() => this.customSchedule());
        this.customPriceObserver.observe(customApp, {
          childList: true, subtree: true, characterData: true,
          attributes: true, attributeFilter: ['class']
        });
      }
      return true;
    }

    customSchedule() {
      if (this.customFrame != null) return;
      this.customFrame = requestAnimationFrame(() => {
        this.customFrame = null;
        if (this.isConnected) this.customUpdate();
      });
    }

    customUpdate() {
      const customPrice = this.customApp?.querySelector('.kaching-bundles__bar--selected .kaching-bundles__bar-price')?.textContent.trim() || '';
      const customNativeHidden = Boolean(this.customApp);
      const customBundleHidden = !customPrice;
      // Do not display a variant amount or stale total while the app is loading
      // or has no selected offer. With no app, preserve the native price markup.
      if (this.customNativePrice.hidden !== customNativeHidden) this.customNativePrice.hidden = customNativeHidden;
      if (this.customBundlePrice.hidden !== customBundleHidden) this.customBundlePrice.hidden = customBundleHidden;
      if (this.customValue.textContent !== customPrice) this.customValue.textContent = customPrice;
    }
  });
}
